import { Type } from "class-transformer";
import { IsNotEmpty, IsEnum, IsDate, IsString, IsBoolean } from "class-validator";
import { eBrandColor } from "../mixins/colorMixin";
import { AbstractJSONModel } from "./master-model";

export enum eCode {
  NormalEvent = 0,
  ClosedEvent = 1,
  PupilFreeTimeEvent = 2
}
export interface IEventTypes {
  id: number;
  name: string;
  institution_id: number;
  created_at: Date;
  updated_at: Date;
  code: eCode;
}

export interface IEventTypesPut {
  id: number;
  name: string;
  code: eCode;
  colour_code: string;
  is_active: boolean;
}

export class EventTypes extends AbstractJSONModel implements IEventTypes {
  public id = -1;
  public name = "";
  public institution_id = -1;
  @IsDate()
  @Type(() => Date)
  public created_at: Date = new Date();
  @IsDate()
  @Type(() => Date)
  public updated_at: Date = new Date();
  @IsNotEmpty()
  @IsEnum(eCode)
  public code: eCode = eCode.NormalEvent;
  @IsString()
  public colour_code: string = eBrandColor.standard;
  @IsBoolean()
  public is_active = true;

  equals(other: IEventTypes): boolean {
    return other.id === this.id;
  }

  public convertToPutObject(): IEventTypesPut {
    const d: IEventTypesPut = Object.assign({});
    d.id = this.id;
    d.name = this.name;
    d.code = this.code;
    d.colour_code = this.colour_code;
    d.is_active = this.is_active;
    return d;
  }
}
